$(function(){

  if($('.element_form #tag_code').length > 0){
    var rfg_page = $('#tag_unique_rfg_id').val().length > 0;
    if(rfg_page){ $('#tag_code').trigger('keyup'); }
  }

  $('.ace-settings-btn').on('click', function(event){
    $('.ace-settings-btn').toggleClass('open');
    $('.ace-settings-box').toggleClass('open');
  });

  $('#tags_table').on('mouseover', '.tag_link', function(event){
    console.log('hover');
  	if($('.ace-settings-box').hasClass('open')){
  	  var tag_code = $(this).html(),
      tag_code_id = $(this).parents('tr').attr('id');

  	  $('#prev_code').val(tag_code);
      $('#prev_tag_id').val(tag_code_id);
  	}
  });

  $('#add_tag').on('click', function(event){
  	//$('.close').trigger('click');
  	var prev_tag_code = $('#prev_code').val(),
        prev_tag_id = $('#prev_tag_id').val(),
  	    path_id = $('#tag_path_id').val(),
  	    code = $('#tag_code').val(),
        node = $('#tag_node').is(':checked'),
        $flash = $('<div>').addClass('alert fade in'),
        $close = $('<button>x</button>').addClass('close').data('dismiss', 'alert');
      $flash.append($close);
      $close.on('click', function(){ $(this).parents('.alert').remove();});

  	if(path_id && code && valid_position(prev_tag_code)){
	  close_alert();

      $.ajax({
        url : "/backend/add_tag",
        method: 'POST',
	  	data: {'prev_tag_code': prev_tag_code, 'prev_tag_id': prev_tag_id, 'tag' : { 'path_id' : path_id, 'code' : code, 'node' : node} },

        success : function (data, status) {
		  $flash.addClass('alert-success').html(data.message);
          append_flash($flash);
          close_settings_box();
          update_table(data);
  	    },

        error : function (request, status, errors) {
      	  $flash.addClass('alert-warning').prepend(request.responseJSON.message);
          append_flash($flash);
	    }
	  });
  	}
  });
});

// helper functions
function valid_position(prev_code){
  var table = $("#tags_table").DataTable(),
  table_length = table.rows()[0].length;
  return  (prev_code || table_length == 0) ? true : false
}

function append_flash($flash){
  $('.breadcrumbs').after($flash);
}

function close_alert(){
  $('.alert').remove();
}

function close_settings_box(){
  $('.ace-settings-box').removeClass('open');
  $('#prev_code, #tag_code').val("");
}

function update_table(data){
    var table = $("#tags_table").DataTable(),
        node = data.node,
        node_boolean_classes = node ? 'ace-icon fa fa-check bigger-110 green boolean_flag' : 'ace-icon fa fa-times bigger-110 red boolean_flag';
    // aggiorno i counter
    table.column(1).nodes().each(function(value, index){
        var cell = table.cell(value),
            cell_data = cell.data();
        if(cell_data >= data.counter){
            new_value = parseInt(cell_data) + 1;
            cell.data(new_value);
        }
    });

    table.row.add([
        "<a class= 'tag_link' href=" + data.edit_path + ">"+ data.code +"</a>",
        ""+data.counter+"",
        ""+data.fixed_point+"",
        "<i class='" + node_boolean_classes + "'></i>",
        "<i class='ace-icon fa fa-times bigger-110 red boolean_flag'></i>",
        "<i class='ace-icon fa fa-times bigger-110 red boolean_flag'></i>",
        "<i class='ace-icon fa fa-times bigger-110 red boolean_flag'></i>",
        "<i class='ace-icon fa fa-times bigger-110 red boolean_flag'></i>",
        "<a href='" + data.delete_path + "' class='" + data.delete_button_class +"' data-confirm=\""+ data.delete_confirmation +"\" data-method='delete' rel='nofollow'> <i class='"+ data.delete_button_icon +"'></i></a>"

    ]).order( [ 1, 'asc' ] ).draw().nodes().to$().addClass('element').attr({id: data.id}).find('td').last().addClass('actions');
}

